goog.provide('el8.app.settings.appPrefs');

goog.require('el8.app.settings.util');
goog.require('el8.data.decisionSupports');
goog.require('el8.data.noteSettings');
goog.require('el8.data.visitNoteFormTemplates');
goog.require('el8.service.urls');
goog.require('el8.template.app.settings.sections');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');
goog.require('el8.data.currUser');


el8.app.settings.appPrefs = (function() {

    var that = {};
    var $container;

    var showEmailNotifications = el8Globals.FEATURES.PatientPortal;
    var showLetterNotifications = el8Globals.FEATURES.Letters;

    that = {

        init: function(_container) {

            $container = _container;

            el8.data.noteSettings.load();
            el8.data.decisionSupports.load();
            var decisionSupports = _.reject(el8.data.decisionSupports.allAsSoyMaps(), function(ds) {
                // Remove the ones that are not configurable
                return !ds.isConfigurable;
            });

            var $content = $(el8.template.app.settings.sections.appPrefs({
                cdsDrugDrugAlertLevels: el8.util.consts.CDS_DRUG_DRUG_ALERT_LEVELS,
                cdsDrugAllergyAlertLevels: el8.util.consts.CDS_DRUG_ALLERGY_ALERT_LEVELS,
                emailNotificationOptions: el8.util.consts.LETTER_EMAIL_NOTIFICATIONS,
                showEmailNotifications: showEmailNotifications,
                showLetterNotifications: showLetterNotifications,
                decisionSupports: decisionSupports
            }));
            $container.html($content).show();

            var form = createForm();
            form.render();
            populateForm(form);

            bindTriggers($content, form);
            // renderLocationList will be bound to 'all' event
            el8.data.serviceLocations.load(null, true);
            // renderVisitNoteFormatByApptTypes will be bound to 'all' event
            el8.data.apptTypes.softLoad(null, true);

        }
    };

    function createForm() {
        var fields = [];

        fields.push({
            name: 'visitNoteFormTemplate',
            selector: ':input[name="visitNoteFormTemplate"]'
        });
        /* NOTE: the various appt-type-note-defaults selects are not members
         * of this form, because their membership can vary as appointment types
         * are added/deleted and it's a pain to keep the form in sync.
         *
         * Since every field saves itself individuall and we don't depend on
         * tabbing through the form, this is a rare place where we can get away
         * with just using the raw inputs. We'll still be able to pretend they're
         * in the form for some functions, like form.setVal and form.getVal.
         */

        if (showEmailNotifications) {
            fields.push({
                name: 'emailNotifications',
                selector: ':input[name="emailNotifications"]'
            });
        }
        if (showLetterNotifications) {
            fields.push({
                name: 'providerLetterNotifications',
                selector: ':input[name="providerLetterNotifications"]'
            });
            fields.push({
                name: 'referralNotifications',
                selector: ':input[name="referralNotifications"]'
            });
        }

        fields.push({
            name: 'cdsDrugDrugAlertLevel',
            selector: ':input[name="cdsDrugDrugAlertLevel"]'
        });
        fields.push({
            name: 'cdsDrugAllergyAlertLevel',
            selector: ':input[name="cdsDrugAllergyAlertLevel"]'
        });

        // CDSs
        fields.push({
            name: 'cdsEnabled',
            selector: ':input[name="cdsEnabled"]',
            castToBool: true
        });
        fields.push({
            name: 'cdsDisplaySupDiag',
            selector: ':input[name="cdsDisplaySupDiag"]',
            castToBool: true
        });
        el8.data.decisionSupports.all().forEach(function(cds) {
            var name = _getIndividualCdsFormName(cds);
            fields.push({
                name: name,
                selector: ':input[name="'+name+'"]',
                castToBool: true
            });
        });
        fields.push({
            name: 'eRxServiceLocation',
            selector: ':input[name="eRxServiceLocation"]'
        });
        fields.push({
            name: 'showDualCoding',
            selector: ':input[name="showDualCoding"]',
            castToBool: true
        });
        fields.push({
            name: 'structuredAssessments',
            selector: ':input[name="structuredAssessments"]',
            castToBool: true
        });

        return new el8.uiwidget.Form({
            container: $('form', $container),
            fields: fields
        });
    }

    function populateForm(form) {
        form.populate({
            'cdsEnabled': el8.data.currUser.isCdsEnabled(),
            'cdsDisplaySupDiag': el8.data.currUser.isCdsDisplaySupDiag(),
            'cdsDrugDrugAlertLevel': el8.data.currUser.getCdsDrugDrugAlertLevel(),
            'cdsDrugAllergyAlertLevel': el8.data.currUser.getCdsDrugAllergyAlertLevel(),
            'showDualCoding': el8.data.currUser.isShowDualCodingEnabled(),
            'structuredAssessments': el8.data.currUser.isStructuredAssessmentsEnabled()
        }, true);

        populateIndividualCdsSettings(form);
        if (el8.data.currUser.isCdsEnabled()) {
            $('.individual-cds-items', $container).show();
        } else {
            $('.individual-cds-items', $container).hide();
        }

        if (showEmailNotifications) {
            form.setVal('emailNotifications', el8.data.currUser.getEmailNotifications(), true);
        }
        if (showLetterNotifications) {
            var providerNotification = el8.data.currUser.getUnreadProviderLetterNotifications() || 'none';
            form.setVal('providerLetterNotifications', providerNotification, true);

            var referralNotification = el8.data.currUser.getUnreadReferralNotifications() || 'none';
            form.setVal('referralNotifications', referralNotification, true);
        }

        populateApptTypes(form);
    }

    function populateIndividualCdsSettings(form) {
        el8.data.decisionSupports.all().forEach(function(cds) {
            var name = _getIndividualCdsFormName(cds);
            var isMeasureEnabled = el8.data.currUser.isCdsMeasureEnabled(cds.getNqfCode());
            form.setVal(name, isMeasureEnabled, true);
        });
    }

    // this will be called after renderVisitNoteFormatByApptTypes, which will re-render
    // all of the selects, so we need to re-populate all of those fields
    function populateApptTypes(form) {
        var allApptTypes = el8.data.apptTypes.sorted();

        var defaultVisitType = el8.data.noteSettings.getDefaultVisitNoteTemplate() || el8.util.consts.DEFAULT_VISIT_NOTE_TEMPLATE;
        form.setVal('visitNoteFormTemplate', defaultVisitType, true);

        for (var i=0; i<allApptTypes.length; i++) {
            var spec = {};
            var apptTypeId = allApptTypes[i].getId();
            var visitNoteTemplate = 'apptTypeVisitNote-'+apptTypeId;
            spec[visitNoteTemplate] = el8.data.noteSettings.getApptTypeVisitNoteById(apptTypeId) ||
                el8.data.noteSettings.getDefaultVisitNoteTemplate() ||
                el8.data.apptTypes.getById(apptTypeId).getVisitNoteFormat() ||
                el8.util.consts.DEFAULT_VISIT_NOTE_TEMPLATE; // we should never get here because the db column has a default

            // Despite the fact that these things aren't in the Form, we can use form.populate,
            // because the widget will fall back to a raw selector for anything with a name
            // attribute matching our key.
            form.populate(spec, true);
        }
    }

    function renderVisitNoteFormatByApptTypes(form) {
        var $section = $('.appt-type-visit-note-format-section', $container);
        $section.html(
            el8.template.app.settings.sections.apptTypeVisitNoteFormatSection({
                apptTypes: el8.data.apptTypes.sorted().map(function(a) { return a.asSoyMap(); }),
                visitNoteFormTemplates: el8.data.visitNoteFormTemplates.all(true)
            })
        );

        populateApptTypes(form);
    }

    function renderLocationList(form) {
        var $section = $('.e-prescribing-section', $container);
        if (el8.data.serviceLocations.all().length <= 1) {
            // still need to clear this out because Practice Location might have been removed from the "Practice Locations" section without a page refresh
            $section.empty();
            return;
        }
        $section.html(
            el8.template.app.settings.sections.ePrescribingSection({
                serviceLocations: el8.data.serviceLocations.sortedAsSoyMaps()
            })
        );
        if (el8.data.currUser.getDefaultErxServiceLocationId()) {
            form.setVal('eRxServiceLocation', el8.data.currUser.getDefaultErxServiceLocationId(), true);
        }
    }

    function bindTriggers($content, form) {

        el8.data.apptTypes.bind('all', function() {
            renderVisitNoteFormatByApptTypes(form);
        });

        el8.data.serviceLocations.bind('all', function() {
            // Only hides if Workspace flag and using workspace location filtering are on
            if(!(el8Globals.FEATURES.Workspaces && el8Globals.WORKSPACE && el8Globals.WORKSPACE.filter_locations)) {
                renderLocationList(form);
            }
        });

        $content.on('change', ':input[name="visitNoteFormTemplate"]',  function(event) {
            var elt = $(this);
            el8.data.noteSettings.updateVisitNoteTemplate(form.getVal('visitNoteFormTemplate'), function() {
                el8.app.settings.util.handleSavedMsg(elt);
                populateApptTypes(form);
            });

        }).on('change', 'select.appt-type-note-defaults',  function(event) {
            var elt = $(this);
            var apptTypeId = $(this).attr('data-id')*1;
            el8.data.noteSettings.updateApptType(apptTypeId,
                form.getVal('apptTypeVisitNote-'+apptTypeId),
                function() {
                    el8.app.settings.util.handleSavedMsg(elt);
                }
            );
        }).on('change', ':input[name="cdsDrugDrugAlertLevel"]',  function(event) {
            el8.data.currUser.setCdsDrugDrugAlertLevel(form.getVal('cdsDrugDrugAlertLevel'));
            var elt = $(this);
            el8.data.currUser.updatePreferencesCDS(function() {
                el8.app.settings.util.handleSavedMsg(elt);
            });
        }).on('change', ':input[name="cdsDrugAllergyAlertLevel"]',  function(event) {
            el8.data.currUser.setCdsDrugAllergyAlertLevel(form.getVal('cdsDrugAllergyAlertLevel'));
            var elt = $(this);
            el8.data.currUser.updatePreferencesCDS(function() {
                el8.app.settings.util.handleSavedMsg(elt);
            });
        }).on('change', ':input[name="cdsEnabled"]',  function(event) {
            el8.data.currUser.setCdsEnabled(form.getVal('cdsEnabled'));
            var elt = $(this);
            if (form.getVal('cdsEnabled')) {
                var enableMeasures = [];
                $(':input.individual-cds-input').each(function() {
                    var elt = $(this);
                    var cds = el8.data.decisionSupports.getById(elt.data('id'));
                    enableMeasures.push(cds.getNqfCode());
                });
                el8.data.currUser.setDecisionSupportsEnabled(enableMeasures);
                populateIndividualCdsSettings(form);

                $('.individual-cds-items').show();
            } else {
                $('.individual-cds-items').hide();
            }

            el8.data.currUser.updatePreferencesCDS(function() {
                el8.app.settings.util.handleSavedMsg(elt.parent().parent().parent());
            });

        }).on('change', ':input[name="cdsDisplaySupDiag"]',  function(event) {
            el8.data.currUser.setCdsDisplaySupDiag(form.getVal('cdsDisplaySupDiag'));
            var elt = $(this);
            el8.data.currUser.updatePreferencesCDS(function() {
                el8.app.settings.util.handleSavedMsg(elt.parent().parent().parent());
            });

        // Covers all individual cds items
        }).on('change', ':input.individual-cds-input',  function(event) {
            var elt = $(this);
            var cds = el8.data.decisionSupports.getById(elt.data('id'));
            var name = _getIndividualCdsFormName(cds);
            var isEnabled = form.getVal(name);
            if (isEnabled) {
                el8.data.currUser.enableCdsMeasure(function() {
                    el8.app.settings.util.handleSavedMsg(elt.parent().parent().parent());
                },
                  cds.getNqfCode());
            } else {
                el8.data.currUser.disableCdsMeasure(function() {
                    el8.app.settings.util.handleSavedMsg(elt.parent().parent().parent());
                },
                  cds.getNqfCode());
            }
        }).on('change', ':input[name="eRxServiceLocation"]',  function(event) {
            el8.data.currUser.setDefaultErxServiceLocationId(form.getVal('eRxServiceLocation'));
            var elt = $(this);
            el8.data.currUser.updatePreferences(function() {
                el8.app.settings.util.handleSavedMsg(elt);
            });

        }).on('change', ':input[name="showDualCoding"]',  function(event) {
            el8.data.currUser.setShowDualCodingEnabled(form.getVal('showDualCoding'));
            var elt = $(this);
            el8.data.currUser.updatePreferences(function() {
                el8.app.settings.util.handleSavedMsg(elt);
            });
        }).on('change', ':input[name="structuredAssessments"]',  function(event) {
            el8.data.currUser.setStructuredAssessmentsEnabled(form.getVal('structuredAssessments'));
            var elt = $(this);
            el8.data.currUser.updatePreferences(function() {
                el8.app.settings.util.handleSavedMsg(elt);
            });
        });


        if (showEmailNotifications) {
            $content.on('change', ':input[name="emailNotifications"]',  function() {
                el8.data.currUser.setEmailNotifications(form.getVal('emailNotifications'));
                var elt = $(this);
                el8.data.currUser.updatePreferences(function() {
                    el8.app.settings.util.handleSavedMsg(elt);
                });
            });
        }

        if (showLetterNotifications) {
            $content.on('change', ':input[name="providerLetterNotifications"]',  function() {
                var providerLetterNotifications = form.getVal('providerLetterNotifications');
                if (providerLetterNotifications === 'none') {
                    el8.data.currUser.setUnreadProviderLetterNotifications(null);
                } else {
                    el8.data.currUser.setUnreadProviderLetterNotifications(providerLetterNotifications);
                }
                var elt = $(this);
                el8.data.currUser.updatePreferences(function() {
                    el8.app.settings.util.handleSavedMsg(elt);
                });
            });
            $content.on('change', ':input[name="referralNotifications"]',  function() {
                var referralNotifications = form.getVal('referralNotifications');
                if (referralNotifications === 'none') {
                    el8.data.currUser.setUnreadReferralNotifications(null);
                } else {
                    el8.data.currUser.setUnreadReferralNotifications(referralNotifications);
                }
                var elt = $(this);
                el8.data.currUser.updatePreferences(function() {
                    el8.app.settings.util.handleSavedMsg(elt);
                });
            });
        }
    }

    // CDS section
    function _getIndividualCdsFormName(cds) {
        return cds.getNqfCode();
    }


    return that;

})();
